module.exports = __webpack_public_path__ + "static/media/icn_mainnav_favourites_light.a8f3732d.svg";